import { FormattedMessage } from "react-intl";

// export const BASE_URL = process.env.REACT_APP_BASE_URL

// export const BASE_URL = "http://192.168.10.6:8018/" // Local
export const BASE_URL = "https://iqc-api.liujo.it/" // NGROK
// export const BASE_URL = "https://qc-check-dev-api.astutesoftwares00.com/"
export const DATE_FORMAT_SERVER = "yyyy-MM-dd";
export const DATE_FORMAT_DISPLAY = "dd/MM/yyyy";
export const ACCESS_TOKEN = "liu_jo_qc_access";

export const STATUS_NEW = {
    value: "new",
    label: <FormattedMessage id="new" defaultMessage={"New"} />,
};
export const STATUS_WORKING = {
    value: "working",
    label: <FormattedMessage id="working" defaultMessage={"Working"} />,
};
export const STATUS_REJECTED = {
    value: "rejected",
    label: <FormattedMessage id="rejected" defaultMessage={"Rejected"} />,
};
export const STATUS_APPROVED = {
    value: "approved",
    label: <FormattedMessage id="approved" defaultMessage={"Approved"} />,
}
export const STATUS_PENDING = {
    value: "pending",
    label: <FormattedMessage id="pending" defaultMessage={"Pending"} />,
}

export const STATUSES = [
    STATUS_NEW,
    STATUS_WORKING,
    STATUS_REJECTED,
    STATUS_APPROVED,
    STATUS_PENDING,
]

export const DASHBOARD_STATUSES = [
    STATUS_REJECTED,
    STATUS_APPROVED,
    STATUS_PENDING,
]

export const JOB_STATUS = [
    {
        value: "approved",
        label: <FormattedMessage id="approved" defaultMessage={"Approved"} />,
    },
    {
        value: "pending",
        label: <FormattedMessage id="pending" defaultMessage={"Pending"} />,
    },
    {
        value: "rejected",
        label: <FormattedMessage id="rejected" defaultMessage={"Rejected"} />,
    },
    {
        value: "working",
        label: <FormattedMessage id="working" defaultMessage={"Working"} />,
    },
    {
        value: "new",
        label: <FormattedMessage id="new" defaultMessage={"New"} />,
    },
]

export const ROLE_ADMIN = {
    value: "admin",
    label: <FormattedMessage id="admin" defaultMessage={"Admin"} />,
}
export const ROLE_CHECKER = {
    value: "checker",
    label: <FormattedMessage id="checker" defaultMessage={"Checker"} />,
}
export const ROLE_CLUSTER_CHECKER = {
    value: "cluster-checker",
    label: <FormattedMessage id="checker" defaultMessage={"Checker"} />,
}


export const ROLE_SUPERVISOR = {
    value: "supervisor",
    label: <FormattedMessage id="supervisor" defaultMessage={"Supervisor"} />,
}

export const ROLES = [
    ROLE_ADMIN,
    ROLE_CHECKER,
    ROLE_SUPERVISOR,
]

export const APP_VERSION = "v1.0.0"

export const JOB_SCREEN_LIST = "job_list";
export const JOB_SCREEN_OVERVIEW = "job_overview";
export const JOB_SCREEN_CHECK_OVERVIEW = "job_check_overview";
export const JOB_SCREEN_CHECK_DETAIL = "job_check_detail";

export const POPUP_SMALL = "small";
export const POPUP_MEDIUM = "medium";
export const POPUP_LARGE = "large";
export const POPUP_TYPE_SIDE = "side";
export const POPUP_TYPE_DEFAULT = "default";

export const initialPopupState = {
    size: POPUP_MEDIUM,
    heading: "",
    hideDefaultClose: false,
    contained: true,
    component: null,
    type: "default"
};

export const LANGUAGE_ACCESS = "qc_checker_lang"
export const EN = "en"
export const IT = "it"

export const CONTROL_AQL = {
    value: "aql",
    label: <FormattedMessage id="aql" defaultMessage={"AQL"} />,
}
export const CONTROL_PERCENTAGE = {
    value: "percentage",
    label: <FormattedMessage id="percentage" defaultMessage={"Percentage"} />,
}
export const CONTROL_QUANTITY = {
    value: "quantity",
    label: <FormattedMessage id="quantity" defaultMessage={"Quantity"} />,
}

export const CONTROL_TYPES = [
    CONTROL_AQL,
    CONTROL_PERCENTAGE,
    CONTROL_QUANTITY,
]

export const CONTROL_CATEGORY_GENERAL = {
    value: "General",
    label: <FormattedMessage id="general" defaultMessage={"General"} />,
}
export const CONTROL_CATEGORY_SPECIAL = {
    value: "Special",
    label: <FormattedMessage id="special" defaultMessage={"Special"} />,
}
export const CONTROL_CATEGORIES = [
    CONTROL_CATEGORY_GENERAL,
    CONTROL_CATEGORY_SPECIAL
]

export const CONTROL_LEVEL_MP = {
    value: "model-part",
    label: <FormattedMessage id="model_part" defaultMessage={"Model Part"} />,
}
export const CONTROL_LEVEL_MPC = {
    value: "model-part-color",
    label: <FormattedMessage id="model_part_color" defaultMessage={"Model Part Color"} />,
}

export const CONTROL_LEVELS = [
    CONTROL_LEVEL_MP,
    CONTROL_LEVEL_MPC,
]

export const CONTROL_LEVEL_MP_PDF = {
    value: "model-part",
    label: <FormattedMessage id="model_part" defaultMessage={"Model Part"} />,
}
export const CONTROL_LEVEL_MPC_PDF = {
    value: "model-part-color",
    label: <FormattedMessage id="model_part_color" defaultMessage={"Model Part Color"} />,
}

export const CONTROL_LEVELS_PDF = [
    CONTROL_LEVEL_MP_PDF,
    CONTROL_LEVEL_MPC_PDF,
]

export const OPTION_YES = {
    value: true,
    label: <FormattedMessage id="yes" defaultMessage={"Yes"} />,
    label: "Yes"
}
export const OPTION_NO = {
    value: false,
    label: <FormattedMessage id="no" defaultMessage={"No"} />,
}

export const OPTIONS_BOOL = [
    OPTION_YES,
    OPTION_NO
]

export const ASSENDING_ORDER = "asc"
export const DESENDING_ORDER = "desc"
export const DEFAULT_SORT_BY = "id"
export const ORDER_DESCENDING = {
    value: "desc",
    label: <FormattedMessage id="most_recent" defaultMessage={"Most Recent"} />,
}
export const ORDER_ASCENDING = {
    value: "asc",
    label: <FormattedMessage id="least_recent" defaultMessage={"Least Recent"} />,
}

export const SORT_ORDERS = [
    ORDER_DESCENDING,
    ORDER_ASCENDING
]
export const LISTING_LIMIT = 10;

export const CLASS_MAJOR = {
    value: "major",
    label: <FormattedMessage id="major" defaultMessage={"Major"} />,
}
export const CLASS_MINOR = {
    value: "minor",
    label: <FormattedMessage id="minor" defaultMessage={"Minor"} />,
}
export const CLASS_CRITICAL = {
    value: "critical",
    label: <FormattedMessage id="critical" defaultMessage={"Critical"} />,
}

export const CLASSIFICATIONS = [
    CLASS_MINOR,
    CLASS_MAJOR,
    CLASS_CRITICAL
]

export const USER_ACTIVE = {
    value: "Active",
    label: <FormattedMessage id="active" defaultMessage={"Active"} />,
}
export const USER_PENDING = {
    value: "Pending",
    label: <FormattedMessage id="pending" defaultMessage={"Pending"} />,
}
export const USER_DISABLED = {
    value: "Disable",
    label: <FormattedMessage id="disabled" defaultMessage={"Disabled"} />,
}

export const USER_STATUS = [
    USER_ACTIVE,
    USER_PENDING,
    USER_DISABLED
]

export const PDF_GRAY = "#dddddd"
export const PDF_BLOCK_TEXT = "10px"
export const PDF_BLOCK_HEADING = "8px"

export const TIME_DAY = {
    value: "day",
    label: <FormattedMessage id="day" defaultMessage={"Day"} />
}
export const TIME_MONTH = {
    value: "month",
    label: <FormattedMessage id="month" defaultMessage={"Month"} />
}
export const TIME_YEAR = {
    value: "YEAR",
    label: <FormattedMessage id="year" defaultMessage={"Year"} />
}

export const TIME_UNIT = [
    TIME_DAY,
    TIME_MONTH,
    TIME_YEAR
]

// MODEL_PART = 'model-part'
// MODEL_COLOR_PART = 'model-color-part'


export const DELIVERY_GROUP = [
    { label: 1, value: '1.0' },
    { label: 2, value: '2.0' },
    { label: 3, value: '3.0' },
    { label: 4, value: '4.0' },
    { label: 5, value: '5.0' },
    { label: 6, value: '6.0' }
]

export const APP_LANGUAGE = "liu_jo_qc_lang";

export const LANGUAGE_OPTIONS = [
    {
        value: {
            code: "en",
            language: "English"
        },
        label: <>
            <div className="flex items-center justify-start gap-2">
                <img src="/images/flags/us.png" alt="English" className="h-6 w-6" />
                <p className="font-semibold">- EN</p>
            </div></>
    },
    {
        value: {
            code: "it",
            language: "Italian",
        },
        label: <>
            <div className="flex items-center justify-start gap-2">
                <img src="/images/flags/it.png" alt="Italian" className="h-6 w-6" />
                <p className="font-semibold">- IT</p>
            </div>
        </>
    },
    {
        value: {
            code: "zh-hans",
            language: "简体中文"
        },
        label: <>
            <div className="flex items-center justify-start gap-2">
                <img src="/images/flags/cn.png" alt="Chinese" className="h-6 w-6" />
                <p className="font-semibold">- CN</p>
            </div>
        </>
    },
]

